export const iconsMap = {
  add: 'add.svg',
  globe: 'globe.svg',
  cog: 'settings.svg',
  copy: 'copy.svg',
  info: 'info-circle.svg',
  success: 'check-circle.svg',
  error: 'close-circle.svg',
  'close-circle': 'close-circle.svg',
  warn: 'info-circle.svg',
  notification: 'bell.svg',
  lock: 'lock.svg',
  unlock: 'unlock.svg',
  'star-full': 'star-full.svg',
  'star-empty': 'star.svg',
  search: 'search.svg',
  delete: 'trash.svg',
  chat: 'chat.svg',
  ellipsis: 'more.svg',
  edit: 'edit.svg',
  cancel: 'close.svg',
  close: 'close.svg',
  eye: 'eye.svg',
  'eye-slash': 'eye-off.svg',
  check: 'check-circle.svg',
  warning: 'warning.svg',
  'arrow-up': 'arrow-up.svg',
  'arrow-down': 'arrow-down.svg',
  'arrow-left': 'arrow-back.svg',
  'arrow-right': 'arrow-forward.svg',
  menu: 'menu.svg',
  activity: 'pulse.svg',
  loading: 'pulse.svg',
  dashboard: 'speedometer.svg',
  fork: 'git-branch.svg',
  commit: 'git-commit.svg',
  tag: 'tag.svg',
  file: 'document.svg',
  book: 'book.svg',
  code: 'code-working.svg',
  'code-empty': 'code.svg',
  'logo-github': 'logo-github.svg',
  logout: 'log-out.svg',
  flash: 'flash.svg',
  time: 'history.svg',
  download: 'cloud-download.svg'
};
